import {
  MERCHANT_INVOICE_INITIATED,
  MERCHANT_INVOICE_LOADED,
  MERCHANT_INVOICE_FAILED,
  MERCHANT_INVOICE_DOWNLOAD_INITIATED,
  MERCHANT_INVOICE_DOWNLOAD_LOADED,
  MERCHANT_INVOICE_DOWNLOAD_FAILED,
} from "../actions/MerchantInvoiceAction";

const initialState = {
  listdata: [],
  pagination: {
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 1,
    nextPage: null,
  },
  loading: false,
  downloading: false,
  error: null,
};

const MerchantInvoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case MERCHANT_INVOICE_INITIATED:
      return { ...state, loading: true, error: null };
    case MERCHANT_INVOICE_LOADED:
      return {
        ...state,
        loading: false,
        listdata: action.payload.data,
        pagination: action.payload.pagination,
      };
    case MERCHANT_INVOICE_FAILED:
      return { ...state, loading: false, error: action.payload };
    case MERCHANT_INVOICE_DOWNLOAD_INITIATED:
      return { ...state, downloading: true };
    case MERCHANT_INVOICE_DOWNLOAD_LOADED:
      return { ...state, downloading: false };
    case MERCHANT_INVOICE_DOWNLOAD_FAILED:
      return { ...state, downloading: false, error: action.payload };
    default:
      return state;
  }
};

export default MerchantInvoiceReducer;
